"use client";

import { useEffect, useState } from "react";
import MasterLayout from "../Sections/MasterLayout";
import {
  Plus,
  Search,
  Pencil,
  RefreshCw,
  Trash2,
  MapPin,
  Filter,
  Power,
  Settings,
  AlertCircle,
  CheckCircle,
  Clock,
} from "lucide-react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import {
  get_all_stations,
  delete_station,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";
export default function Stations() {
  const navigate = useNavigate();
  const [stationData, setStationData] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [selectedStations, setSelectedStations] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [showDisableModal, setShowDisableModal] = useState(false);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedStation, setSelectedStation] = useState(null);
  const [showAddStationModal, setShowAddStationModal] = useState(false);
  const [editMode, setEditMode] = useState(false); // New state for edit mode
  const [newStation, setNewStation] = useState({
    name: "",
    code: "",
    line: "",
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilter = (event) => {
    setFilterStatus(event.target.value);
  };

  const handleSelectStation = (stationId) => {
    setSelectedStations((prev) =>
      prev.includes(stationId)
        ? prev.filter((id) => id !== stationId)
        : [...prev, stationId]
    );
  };

  const handleSelectAll = () => {
    if (selectedStations.length === filteredStations.length) {
      setSelectedStations([]);
    } else {
      setSelectedStations(filteredStations.map((station) => station.id));
    }
  };

  const handleToggleStatus = (station) => {
    setSelectedStation(station);
    setShowDisableModal(true);
  };

  const confirmToggleStatus = () => {
    setStationData((prev) =>
      prev.map((station) =>
        station.id === selectedStation.id
          ? {
              ...station,
              status: station.status === "1" ? "Inactive" : "Active",
            }
          : station
      )
    );
    setShowDisableModal(false);
    setSelectedStation(null);
  };

  const handleDelete = (station) => {
    setSelectedStation(station);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    setStationData((prev) =>
      prev.filter((station) => station.id !== selectedStation.id)
    );
    setSelectedStations((prev) =>
      prev.filter((id) => id !== selectedStation.id)
    );
    setShowDeleteModal(false);
    setSelectedStation(null);
  };

  const handleEditStation = (station) => {};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewStation((prev) => ({ ...prev, [name]: value }));
  };

  const filteredStations = stationData.filter((station) => {
    const matchesSearch =
      station.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      station.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      station.line.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus =
      filterStatus === "All" || station.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  const getStatusIcon = (status) => {
    switch (status) {
      case "0":
        return <CheckCircle className="h-4 w-4 text-green-500" />;
      case "3":
        return <Clock className="h-4 w-4 text-yellow-500" />;
      case "1":
        return <AlertCircle className="h-4 w-4 text-red-500" />;
      default:
        return <CheckCircle className="h-4 w-4 text-gray-500" />;
    }
  };

  const getLineColor = (line) => {
    switch (line) {
      case "Blue Line":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Blue":
        return "bg-blue-100 text-blue-800 border-blue-200";
      case "Green Line":
        return "bg-green-100 text-green-800 border-green-200";
      case "Green":
        return "bg-green-100 text-green-800 border-green-200";
      case "Red Line":
        return "bg-red-100 text-red-800 border-red-200";
      case "Red":
        return "bg-red-100 text-red-800 border-red-200";
      case "Yellow Line":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      case "Yellow":
        return "bg-yellow-100 text-yellow-800 border-yellow-200";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200";
    }
  };

  const getStatusButtonColor = (status) => {
    console.log("Stat", status);
    switch (status) {
      case "0":
        return "text-green-600 hover:bg-green-100";
      case "1":
        return "text-red-600 hover:bg-red-100 ";
      default:
        return "text-green-600 hover:bg-green-100";
    }
  };

  useEffect(() => {
    master_get_data();
  }, []);

  const master_get_data = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("city_prefix", "Indore_metro");
    await server_post_data(get_all_stations, fd)
      .then((Response) => {
        const mappedStations = Response?.data?.data.map((station) => ({
          id: station.station_id,
          name: station.name,
          code: station.code,
          line: station.multiple_line,
          status: "Active", // Defaulting to "Active" (adjust if backend provides status)
          interchanges: 0, // Set properly if your backend returns this
          lastMaintenance: station.entry_date.split("T")[0], // Extract date part only
          coordinates: `${station.latitude.toFixed(
            4
          )}° N, ${station.longitude.toFixed(4)}° E`,
        }));

        setStationData(mappedStations);
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.error("Failed to fetch stations:", error);
        setShowLoaderAdmin(false);
      });
  };

  const deletestation = async (station_id) => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("city_prefix", "Indore_metro");
    fd.append("station_id", station_id);
    await server_post_data(delete_station, fd)
      .then((Response) => {
        // const mappedStations = Response?.data?.data.map((station) => ({
        //   id: station.station_id,
        //   name: station.name,
        //   code: station.code,
        //   line: station.multiple_line,
        //   status: "Active", // Defaulting to "Active" (adjust if backend provides status)
        //   interchanges: 0, // Set properly if your backend returns this
        //   lastMaintenance: station.entry_date.split("T")[0], // Extract date part only
        //   coordinates: `${station.latitude.toFixed(
        //     4
        //   )}° N, ${station.longitude.toFixed(4)}° E`,
        // }));

        // setStationData(mappedStations);
        setShowDeleteModal(false);
        master_get_data();
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        console.error("Failed to Delete station:", error);
        setShowLoaderAdmin(false);
      });
  };

  //   const master_data_get = async () => {
  //   setShowLoaderAdmin(true);
  //   await server_post_data(, null)
  //     .then((Response) => {
  //       let data = Response.split("~@~");
  //       if (parseInt(data[0]) === 1) {
  //         handleError(data[1]);
  //       } else {
  //         const final_data = JSON.parse(data[1]);
  //         setReviewLInk(final_data.review_linkss_link);
  //         setReviewData(final_data.review_linkss_data.slice().reverse());
  //       }
  //       setShowLoaderAdmin(false);
  //     })
  //     .catch((error) => {
  //       handleError("network");
  //       setShowLoaderAdmin(false);
  //     });
  // };

  return (
    <MasterLayout>
      <main className="min-h-screen bg-gray-50">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-3">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900 mb-0">
                Metro Stations Management
              </h1>
              <p className="text-sm text-gray-600 mt-1 mb-0">
                Manage all metro stations, their details, and status
              </p>
            </div>
            <button
              onClick={() => {
                navigate("/add-stations");
              }}
              className="inline-flex items-center justify-center gap-2 bg-[var(--primary-color)] text-white px-4 py-2 rounded-md hover:bg-[var(--primary-hover)] transition duration-200"
            >
              <Plus className="h-5 w-5" />
              Add Station
            </button>
          </div>
        </div>

        {/* Search & Filter Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
          <div className="flex flex-col lg:flex-row gap-4">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-gray-50"
                placeholder="Search stations by name, code, or line..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
            <div className="flex gap-3">
              <select
                className="px-[35px] py-3 border border-gray-300 rounded-lg form-select"
                value={filterStatus}
                onChange={handleFilter}
              >
                <option value="All">All Status</option>
                <option value="Active">Active</option>
                <option value="Maintenance">Maintenance</option>
                <option value="Inactive">Inactive</option>
              </select>
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="inline-flex items-center gap-2 px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition duration-200"
              >
                <Filter className="h-5 w-5" />
                Filters
              </button>
            </div>
          </div>
        </div>

        {/* Stations Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <h3 className="text-xl font-semibold text-gray-900">
                  All Stations ({filteredStations.length})
                </h3>
                {selectedStations.length > 0 && (
                  <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                    {selectedStations.length} selected
                  </span>
                )}
              </div>
              {selectedStations.length > 0 && (
                <div className="flex gap-2">
                  <button className="text-sm bg-red-600 hover:bg-[var(--primary-hover)] text-[var(--white)] px-3 py-2 rounded-md">
                    Delete Selected
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-left">
                    <input
                      type="checkbox"
                      checked={
                        selectedStations.length === filteredStations.length &&
                        filteredStations.length > 0
                      }
                      onChange={handleSelectAll}
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    Station Details
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    Line
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    Status
                  </th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    Interchanges
                  </th>
                  <th
                    className="px-6 py-4 text-right text-sm font-semibold text-gray-900 "
                    style={{ paddingRight: "3rem" }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {filteredStations.map((station) => (
                  <tr
                    key={station.id}
                    className="hover:bg-gray-50 transition duration-150"
                  >
                    <td className="px-6 py-4">
                      <input
                        type="checkbox"
                        checked={selectedStations.includes(station.id)}
                        onChange={() => handleSelectStation(station.id)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex flex-col">
                        <span className="font-semibold text-gray-900 text-base">
                          {station.name}
                        </span>
                        <span className="text-sm text-gray-500 font-mono">
                          {station.code}
                        </span>
                        <span className="text-xs text-gray-400 mt-1">
                          {station.coordinates}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span
                        className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border ${getLineColor(
                          station.line
                        )}`}
                      >
                        {station.line}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        {getStatusIcon(station.status)}
                        <span
                          className={`px-3 py-1 rounded-full text-sm font-medium ${
                            station.status === "Maintenance"
                              ? "bg-yellow-100 text-yellow-800"
                              : station.status === "Active"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {station.status}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <span className="text-lg font-semibold text-gray-900">
                          {station.interchanges}
                        </span>
                        {station.interchanges > 0 && (
                          <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                            Hub
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center justify-end gap-1">
                        <button
                          className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition duration-200"
                          title="Edit Station"
                          onClick={() => {
                            navigate(`/edit-stations/${station.id}`);
                          }}
                        >
                          <Pencil className="h-4 w-4" />
                        </button>
                        {/* <button
                          title={
                            station.status === "0"
                              ? "Disable Station"
                              : "Enable Station"
                          }
                          className={`p-2 ${getStatusButtonColor(
                            station.status
                          )} rounded-md transition duration-200`}
                          onClick={() => handleToggleStatus(station)}
                        >
                          <Power className="h-5 w-5" />
                        </button> */}
                        <button
                          className="p-2 text-red-600 hover:bg-red-100 rounded-lg transition duration-200"
                          title="Delete Station"
                          onClick={() => handleDelete(station)}
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredStations.length === 0 && (
            <div className="text-center py-12">
              <MapPin className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No stations found
              </h3>
              <p className="text-gray-500">
                Try adjusting your search or filter criteria.
              </p>
            </div>
          )}
        </div>
        {/* Pagination */}
        {filteredStations.length > 0 && (
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 px-6 py-4 mt-6">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-700">
                Showing <span className="font-medium">1</span> to{" "}
                <span className="font-medium">{filteredStations.length}</span>{" "}
                of{" "}
                <span className="font-medium">{filteredStations.length}</span>{" "}
                results
              </div>
              <div className="flex gap-2">
                <button
                  className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:text-[var(--black)] disabled:opacity-50"
                  disabled
                >
                  Previous
                </button>
                <button className="px-3 py-2 text-sm bg-[var(--primary-color)] text-white rounded-md hover:bg-[var(--primary-hover)]">
                  1
                </button>
                <button
                  className="px-3 py-2 text-sm border border-gray-300 rounded-md hover:text-[var(--black)] disabled:opacity-50"
                  disabled
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Disable/Enable Modal */}
        <Modal
          show={showDisableModal}
          onHide={() => setShowDisableModal(false)}
          centered
        >
          <Modal.Header closeButton className="border-bottom-0">
            <Modal.Title>
              {selectedStation?.status === "Active" ? "Disable" : "Enable"}{" "}
              Station
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-gray-700">
              Are you sure you want to{" "}
              {selectedStation?.status === "Active" ? "disable" : "enable"}{" "}
              <span className="font-semibold">{selectedStation?.name}</span>?
            </p>
          </Modal.Body>
          <Modal.Footer className="border-top-0">
            <Button
              variant="secondary"
              onClick={() => setShowDisableModal(false)}
              className="rounded-md px-4 py-2"
            >
              Cancel
            </Button>
            <Button
              variant={
                selectedStation?.status === "Active" ? "danger" : "success"
              }
              onClick={confirmToggleStatus}
              className="rounded-md px-4 py-2"
            >
              {selectedStation?.status === "Active" ? "Disable" : "Enable"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Modal */}
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton className="border-bottom-0">
            <Modal.Title>Delete Station</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-gray-700">
              Are you sure you want to delete{" "}
              <span className="font-semibold">{selectedStation?.name}</span>?
              This action cannot be undone.
            </p>
          </Modal.Body>
          <Modal.Footer className="border-top-0">
            <Button
              variant="secondary"
              onClick={() => setShowDeleteModal(false)}
              className="rounded-md px-4 py-2"
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                deletestation(selectedStation?.id);
              }}
              className="rounded-md px-4 py-2"
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </main>
    </MasterLayout>
  );
}
